<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="h-screen no-gutter items-center cash-page">
    <div class="fix-box">
      <logo-img></logo-img>
      <lang-select></lang-select>
    </div>
    <el-row
      type="flex"
      justify="center"
      class="vs-row-login"
    >
      <el-col
        :xs="24"
        :sm="24"
        :md="16"
        :lg="12"
        :xl="12"
        class="vs-col-col"
      >
          <div class="inner">
            <h1 class="title pr">
              <span class="bar pa"></span>
              {{$t('orders.orderInformation')}}
            </h1>
            <div class="content">
              <div class="content-top">
                <div class="top-left">
                  <span>{{$t('orders.theAmountToBePaid')}}: </span>
                  <span class="red">{{userInfo.payAmount?userInfo.payAmount:""}}</span>
                  USDT
                </div>
                <div class="top-right">
                  {{$t('orders.orderNumber')}}:
                  {{userInfo.serialNo?userInfo.serialNo:""}}
                </div>
              </div>
              <div class="content-countdown">
                <span>{{$t('orders.remainingPaymentTime')}}:</span>
                <span class="red">
                  <count-down
                    :count-down="countDown"
                  ></count-down>
                </span>
              </div>
              <div class="qr-module">
                <!-- <el-image
                  :src="userInfo.url"
                  class="qr-img"
                  :preview-src-list="[userInfo.url]"
                ></el-image> -->
                <img :src="userInfo.url" class="qr-img"/>
                <div class="qrimg-right">
                  <h2 class="address-title">TRC20</h2>
                  <div class="bg-box">{{userInfo.address?userInfo.address:""}}</div>
                  <div class="btn-box">
                    <vs-button @click="copyHandle">{{$t('orders.copy')}}</vs-button>
                  </div>
                </div>
              </div>
            </div>
            <h4 class="title">
              {{$t('orders.tipstitle')}}
              <span class="bar pa">

              </span>
            </h4>
            <p class="desc"> {{$t('orders.tips.first')}}</p>
            <p class="desc"> {{$t('orders.tips.second')}}</p>
<!--            <p class="desc">3.使用环楚USDT钱包，快速存入无手续费。<a class="link-wallet" :href="domain" target="_blank">查看钱包App。</a></p>-->
<!--            链接钱包h5地址-->
            <p class="desc"> {{$t('orders.tips.third')}}</p>
            <p class="desc"> {{$t('orders.tips.fourth')}}</p>
          </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import countDown from '@/components/cashier/countDown'
  import langSelect from '@/components/cashier/langSelect'
  import { queryOrderInfo } from '@/api/cashier'
  import copy from 'copy-to-clipboard'
  import Logo from '@/layouts/components/Logo'
export default{
    components:{
      Logo,
      countDown,
      langSelect
    },
  data() {
    return {
      userInfo: {
        amount: '',
        address: '',
        payAmount: '',
        serialNo: '',
      },
      tips: [
        '订单过期后请勿支付，否则将不入账不退款。',
        '区块链转帐需等待一定数量的区块确认后才会到帐，请耐心等待。',
        '使用环楚USDT钱包，快速存入无手续费。查看钱包App。',
        '使用环楚USDT钱包，快速存入无手续费。查看钱包App。',
        '请留意您发起提币的平台是否有收取手续费，这将影响您的实际到帐金额。',
        '请务必确认电脑及浏览器安全，防止消息被篡改或泄露。',
      ],
      countDown: 0,
    }
  },
  created(){
    if(this.$i18n.locale&&this.$i18n.locale == "zh_CN"){
      document.title = '收银台';
    }else{
      document.title = 'cashier';
    }
    
      this.getInfo();
  },
  mounted(){

  },
  computed: {
    domain() {
      return process.env.VUE_APP_URL;
    }
  },
  methods: {
    copyHandle(){
      copy(this.userInfo.address);
      this.$vs.notify({
        text: this.$t('orders.theReplicationIsSuccessful'),
        position: 'top-right'
      })
    },
    getInfo(){
      queryOrderInfo({
        serialNo: this.$route.query.serialNo
      }).then((res) => {
        console.log(res);
        if(res.data){
          this.userInfo = res.data;
          let nowTap = Date.parse(new Date());
          this.countDown = this.userInfo.validDate - (+nowTap / 1000);
        }
      }).catch((error) => {
        this.countDown = 0;
      })
    }
  },
}
</script>

<style lang="scss">
  @import "../assets/scss/variable";
  
  .cash-page {
    background-color: #F8F8F8;
    .login-left {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .logo-left-bg {
        width: 70%;
      }


    }
    .vs-row-login,
    .vs-col-col {
      height: 100%;
    }
    .top-right {
      word-break: break-all;
    }
  }
  .fix-box {
    position: fixed;
    z-index: 999;
    top: 0;
    width: 100%;
    height: 62px;
    background-color: #fff;
    padding-top: 15px;
    padding-left: 20px;
    .vs-con-dropdown{
      float: right;
      position: relative;
      right: 60px;
      top: 10px;
      i{
        position: relative;
        top: -1px;
      }
      span{
        position: relative;
        top: -3px;
      }
    }
  }
  .inner {
    margin-top: 100px;
    .title {
      font-size: 20px;
      color: #6E6B7B;
      margin-bottom: 20px;
      position: relative;
      padding-left: 20px;
      font-weight: 700;
      .bar {
        position: absolute;
        top: 2px;
        left: 0;
        width: 4px;
        height: 20px;
        background-color: $themeColor;
      }
    }
    .content {
      background-color: #fff;
      border-radius: 5px;
      padding: 40px;
      margin-bottom: 50px;
      .content-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        font-size: 20px;
      }
      .content-countdown {
        font-size: 20px;
      }
      .qr-module {
        margin-top: 30px;
        .qr-img {
          width: 150px;
          height: 150px;
          margin-right: 20px;
        }
        .qrimg-right {
          flex: 1;
        }
        .address-title {
          margin-bottom: 5px;
        }
        .bg-box {
          background-color: #F4F5F9;
          padding: 10px 20px;
          margin-bottom: 10px;
          word-break: break-all;
        }
        .btn-box {
          text-align: right;
        }

      }
    }
  }

.red {
  color: red;
}
  .login-right {
    width: 100%;
    padding: 0 5.28rem;
    .tips {
      margin-bottom: 30px;
    }
  }
  @media screen and (min-width: 768px) {
    .cash-page {
      padding: 20px;
    }
    .qr-module {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  @media screen and (max-width: 768px) {
    .cash-page {
      padding: 20px;
      .content {
        padding: 20px;
      }
      .content-top {
        flex-wrap: wrap;
      }
      .qrimg-right {
        margin-top: 10px;
      }
    }
  }
</style>
